'use client';
import React, { useEffect, useState } from 'react';
import { Select } from '@pezeshk-book/ui-kit';
import { CustomAccordionProps } from './custom-accordion.props';
import { useDispatch, useSelector } from 'react-redux';
import { UsersActions } from '@store/users/users-action';
import { RootState } from '@store/root-reducer';

const CustomAccordion = ({ title, data, type }: CustomAccordionProps) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state: RootState) => state.users);

  const [select, setSelect] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!filters[type]?.value) {
      setSelect(title);
    }
  }, [filters]);

  const handleSelect = (item: any) => {
    setSelect(item);
    const selectedTitle = data.filter((dataRow: any) => dataRow.id.toString() === item);
    dispatch(UsersActions.setFilterItems({ key: type, id: item, value: selectedTitle[0]?.title }));
  };

  return (
    <Select
      label={title}
      autoComplete={true}
      optionsList={data}
      value={select?.toString() || ''}
      onChange={handleSelect}
      id={'id'}
      text={'title'}
    />
  );
};

export default CustomAccordion;
